import Extraction from './Extraction';

export default Extraction;
